import {NgModule} from '@angular/core';
import {CommonModule, CurrencyPipe, DatePipe} from '@angular/common';
import {SalutationPipe} from 'src/shared/share-pipes/pipes/salutation.pipe';
import {PhonePipe} from './pipes/phone.pipe';
import {RolePipe} from './pipes/role.pipe';
import {DurationPipe} from './pipes/duration.pipe';
import {FileSizePipe} from './pipes/filesize.pipe';
import {SafeHtmlPipe} from './pipes/safe-html.pipe';
import {FileExplorerIconPipe} from './pipes/file-explorer-icon.pipe';
import {BasenamePipe} from './pipes/basename.pipe';
import {StartCasePipe} from './pipes/start-case.pipe';
import {SmartCurrencyPipe} from "@shared/share-pipes/pipes/smart-currency.pipe";
import {SafeDatePipe} from "@shared/share-pipes/pipes/safe-date.pipe";
import {PercentFixedPipe} from "@shared/share-pipes/pipes/percent-fixed.pipe";

@NgModule({
  declarations: [
    SalutationPipe,
    PhonePipe,
    RolePipe,
    DurationPipe,
    FileSizePipe,
    SafeHtmlPipe,
    FileExplorerIconPipe,
    BasenamePipe,
    StartCasePipe,
    SmartCurrencyPipe,
    SafeDatePipe,
    PercentFixedPipe
  ],
  providers: [CurrencyPipe, DatePipe],
  imports: [CommonModule],
  exports: [SalutationPipe, PhonePipe, RolePipe, DurationPipe, FileSizePipe, SafeHtmlPipe, FileExplorerIconPipe, BasenamePipe, StartCasePipe, SmartCurrencyPipe, SafeDatePipe, PercentFixedPipe],
})
export class SharePipesModule {
}
